const currencyFormatter = new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'CLP',
  maximumFractionDigits: 0,
});

/**
 * Format a numeric value as Chilean peso currency.
 * @param {number|string} value
 * @returns {string}
 */
export function formatCurrency(value) {
  if (value === undefined || value === null) return '—';
  return currencyFormatter.format(Number(value));
}
